import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const generateMeasurementPdf = {
    namespaced: true,
    state: {
        isMeasurementGenerating: [],
        textInfoMeasurementPdfSave: "",
        typeInfoMeasurementPdfSave: "",
        headInfoMeasurementPdfSave: "",
    },
    mutations: {
        DATA_SAVE_SUCCESS(state, response, item) {
            state.isMeasurementGenerating.splice(state.isMeasurementGenerating.indexOf(item), 1);
            eventBus.$emit("generateMeasurementPdfSuccess", response.data)
        },
        DATA_SAVE_FAILURE(state, error, item) {
            state.isMeasurementGenerating.splice(state.isMeasurementGenerating.indexOf(item), 1);
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                eventBus.$emit("generateMeasurementPdfFailure", error.response.data.errors);
            }       
        },
    },
    actions: {
        generateMeasurement: function({ dispatch, state }, payload) {
            let url = new URL(window.location.href);
            let id = url.searchParams.get("id");
            let promise = sendRequest("get", config.baseURLApi + "/measurements/" + payload.item.id + "/" + id + "/generate-measurement-pdf", {}, {}, true);
            state.isMeasurementGenerating.push(payload.item);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1], payload.item);
                } else {
                    dispatch("failureDataSave", result[1], payload.item);
                }
            });
        },
        successDataSave: function({ commit }, response, item) {
            commit("DATA_SAVE_SUCCESS", response, item);
        },
        failureDataSave: function({ commit }, error, item) {
            commit("DATA_SAVE_FAILURE", error, item);
        },
    }
}

export default generateMeasurementPdf;